import { SETS, SET_CONFIGS } from './constants'
import { getState } from './state'
import {
  getStateSets,
  getState as getStateSetState,
} from '@/js/plugins/store/helper/requestSet/state.js'
import { getMutations as getStateSetMutations } from '@/js/plugins/store/helper/requestSet/mutations'
import { getActions as getStateSetActions } from '@/js/plugins/store/helper/requestSet/actions'
import { getGetters as getStateSetGetters } from '@/js/plugins/store/helper/requestSet/getters'
import getters from './getters'
import mutations from './mutations'
import actions from './actions'

export const STATE_SETS = getStateSets(SETS)
const stateSetState = getStateSetState(STATE_SETS)
const stateSetGetters = getStateSetGetters(STATE_SETS)
const stateSetActions = getStateSetActions(STATE_SETS, SET_CONFIGS)
const stateSetMutations = getStateSetMutations(STATE_SETS)

export const getAppModule = appConfig => {
  return {
    namespaced: true,
    state: { ...getState(appConfig), ...stateSetState },
    getters: { ...getters, ...stateSetGetters },
    mutations: { ...mutations, ...stateSetMutations },
    actions: {
      ...actions,
      ...stateSetActions,
    },
  }
}
